// src/accentBus.ts
export let currentAccent = "#378add";

export function setCurrentAccent(a: string) {
  currentAccent = a;
}
